import get from 'lodash/get';
import { useTranslation } from '@packages/utils';
import { Modal } from 'components/Base/Modal';
import useForm from 'hooks/useForm';
import { TValidateFieldsError } from 'data/types/generic.types';
import { TEventCreateUI } from 'data/types/events.types';
import { useCreateEventMutation } from 'redux/apiSlice/events.slice';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { TCreateEventModalProps } from './CreateEventModal.types';
import CreateEventForm from './CreateEventForm';

const CreateEventModal = ({ open, setOpen }: TCreateEventModalProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.events.list.actions.create-event.modal',
  });
  const { showToastNotification } = useShowToastNotification();
  const { form } = useForm<TEventCreateUI>();
  const [createEvent, { isLoading }] = useCreateEventMutation();

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      const values = (await form.validateFields()) as TEventCreateUI;
      const payload = {
        ...values,
        hostedPrivately: true,
      };
      await createEvent(payload).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
      handleClose();
    } catch (e) {
      if (!(e as TValidateFieldsError)?.errorFields) {
        const message = get(e, 'data.message');
        showToastNotification({
          message,
          type: ENotificationType.ERROR,
        });
      }
    }
  };

  return (
    <Modal
      title={t('TITLE')}
      open={open}
      onCancel={handleClose}
      onOk={handleSubmit}
      okText={t('SUBMIT_BTN')}
      cancelText={t('CANCEL_BTN')}
      okButtonProps={{ loading: isLoading }}
      data-cy="create-event-modal"
    >
      <CreateEventForm form={form} />
    </Modal>
  );
};

export default CreateEventModal;
